export class HomeRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_HOME = 'home';

    public static readonly ROUTE_BASE = `/${HomeRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_HOME = `/${HomeRoutingNames.NAME_HOME}`;
}
